/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-danger */
import React, { useState } from "react";
import Empty from "../../../../shared/Empty/Empty";
import Table, {
  TableAction,
  TableBody,
  TableHeading,
} from "../../../../shared/Table/Table";
import {
  RootStore,
  useAppDispatch,
  useAppSelector,
} from "../../../../store/store";
import {
  setShowPageCoursePriceModal,
  singlePageCoursePrice,
} from "../../../../store/features/AdminPanel/CoursePrice/CoursesPriceSlice";
import { deletePagecoursePrice } from "../../../../store/features/AdminPanel/CoursePrice/CoursesPriceApi";
import DeleteModal from "../../../../shared/DeleteModal/DeleteModal";

const PageCoursePriceContent = () => {
  const [deleteId, setDeleteId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const dispatch = useAppDispatch();
  const handleEdit = (data: any) => {
    dispatch(singlePageCoursePrice(data));
    dispatch(setShowPageCoursePriceModal(true));
  };
  const coursePriceState = useAppSelector(
    (store: RootStore) => store.CoursesPriceSlice
  );
  const handleDelete = (id: any) => {
    setDeleteId(id);
    setDeleteModal(true);
    
  };
  const deletePagePrice = () => {
    dispatch(deletePagecoursePrice({ id: deleteId })).then(() => {
      setDeleteModal(false);
      setDeleteId(null);
    });
  };
  return (
    <div className="tenant__table__wrapper">
      <div className="user__table__section">
        <Table
          heading={
            <TableHeading>
              <th>Name</th>
              <th>Course Price($)</th>
              <th>Description</th>
              <th className="hide__text">.</th>
            </TableHeading>
          }
        >
          <TableBody>
            {coursePriceState?.courses_price?.map((item: any) => {
              return (
                <tr>
                  <td>{item.name}</td>
                  <td>${item.price}</td>
                  <td
                    className="weekly_description"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />
                  <TableAction
                    onDelete={() => handleDelete(item.id)}
                    onEdit={() => handleEdit(item)}
                  />
                </tr>
              );
            })}
          </TableBody>
        </Table>
        {!coursePriceState.loading.get &&
          coursePriceState?.courses_price?.length === 0 && (
            <div className="mt-5 handle__empty__container__div">
              <Empty emptyText="It seems empty." custombg={true} />
            </div>
          )}
      </div>
      <DeleteModal
        showModal={deleteModal}
        setShowModal={setDeleteModal}
        onClick={deletePagePrice}
        loading={coursePriceState?.loading.delete &&!coursePriceState?.req_success.delete}
      />
    </div>
  );
};

export default PageCoursePriceContent;
